export default function(Mousetrap) {
    let _handleKey = Mousetrap.prototype.handleKey

    Mousetrap.prototype.handleKey = function(character, modifiers, e) {
        let self = this
        let element = e.target

        const rx = /INPUT|TEXTAREA/i
        const rxType = /checkbox|radio|submit|button/i

        if (character === "backspace") {
            if(!rx.test(element.tagName) || rxType.test(element.type) || element.disabled || element.readOnly) {
                if (e.preventDefault) e.preventDefault()
                e.returnValue = false
            }
        }

        return _handleKey.call(self, character, modifiers, e)
    }

    Mousetrap.init()
    
    return Mousetrap
}